module.exports = __webpack_public_path__ + "static/media/AuthIcon.68823b75.png";